import type { IncomingWebhookStatus } from "./types";

export function shortWebhookId(id: string): string {
  return id.slice(0, 8);
}

export function webhookStatusLabel(status: IncomingWebhookStatus | string): string {
  if (status === "active") return "有効";
  if (status === "pending") return "発行中";
  if (status === "revoked") return "失効";
  return status;
}

export function formatWebhookTimestamp(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return new Date(value).toLocaleString("ja-JP");
}

export function webhookCacheContainsSecret(data: unknown, url: string): boolean {
  if (!url) return false;
  try {
    return JSON.stringify(data).includes(url);
  } catch {
    return false;
  }
}
